import { render, staticRenderFns } from "./ProductsTab.vue?vue&type=template&id=617a9e6e&scoped=true"
import script from "./ProductsTab.vue?vue&type=script&lang=js"
export * from "./ProductsTab.vue?vue&type=script&lang=js"
import style0 from "./ProductsTab.vue?vue&type=style&index=0&id=617a9e6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617a9e6e",
  null
  
)

export default component.exports